export const defaultCartItem = {
  cart_id: 0,
  cart_item_key: 0,
  product_code: "",
  quantity: 1,
  last_price: 0,
  last_modified_date: "2000-01-01",
  product: {
    description: "",
    shipping_weight: 0,
  },
};

export const defaultCart = {
  cart_key: 0,
  customer_num: 0,
  cart_total: 0,
  last_modified_date: "2000-01-01",
  last_modified_by: "",
  created_by: "",
};
